import React, { Component } from "react";

// Assets
import Coffee from "../../Assets/coffee.svg";
import backBtn from "../../Assets/backBtn.svg";

// Component
import RecipeCard from "./RecipeCard";
import RecipeDetails from './RecipeDetails';


// FoodSection Component
class FoodSection extends Component {
  // constructor function
  constructor(props) {
    super(props);

    this.state = {
      // false show coffee button, true show back button
      activePage: false,
    };
  }

  // page change logic
  changePage = () => {

    console.log(this.state.activePage)
    if (this.state.activePage) {
      this.setState({ activePage: false });
    }else 
      this.setState({ activePage: true });
  }

  render() {
    return (
      <div className="FoodSection">
        <div
          className="backBtn"
          onClick={() => {
            this.changePage();
          }}
        >
          <img src={this.state.activePage ? backBtn : Coffee} alt="Setting" />
        </div>

        <div className="FoodSection_Holder">
          {this.state.activePage ? (
            <RecipeDetails />
          ) : (
            <RecipeCard changePage={this.changePage} />
          )}
        </div>
      </div>
    );
  }
}

export default FoodSection;
